import * as React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';

export interface Props {
  children: any;
  desktopPadding?: string | null;
}

function FooterRowWrapper({ children, desktopPadding = null }: Props) {
  return (
    <Wrapper>
      <InnerWrapper desktopPadding={desktopPadding}>{children}</InnerWrapper>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  width: 100%;
  border-bottom: ${({ theme }) => theme.borders.footer};
`;

const InnerWrapper = styled.div<{ desktopPadding: string | null }>`
  display: flex;
  max-width: ${({ theme }) => `${theme.grid.container.wide}px`};
  padding: ${rem(32)} ${rem(24)};
  width: 100%;
  margin: 0 auto;

  ${props =>
    props.desktopPadding
      ? `
    padding: ${props.desktopPadding};
  `
      : ''}

  justify-content: space-between;

  ${({ theme }) => theme.mediab.l1150`
    padding: ${rem(32)} ${rem(16)};
  `}

  ${({ theme }) => theme.mediab.l925`
      flex-flow: column;
      align-items: center;
  `};
`;

export { FooterRowWrapper as CorporateFooterRowWrapper };
